module.exports = __webpack_public_path__ + "images/emoji/mortar_board.f9e6ea00767e5b9aeb27.png";